export const locale = {
    lang: 'nl',
    data: {
        'NAV': {
            'APPLICATIE': 'Applicatie',
            'MEDEWERKERS': {   
                'TITEL' : 'Medewerkers',
                'OVERZICHT': 'Overzicht',
            },
            'AFDELINGEN': {   
                'TITEL' : 'Afdelingen',
                'OVERZICHT': 'Overzicht',
            },
            'PLANNING': {   
                'TITEL' : 'Planning',
                'OVERZICHT': 'Bewerken',
            },
            'BUITENDIENST': {   
                'TITEL' : 'Buitendienst',
                'WERKBON': 'Werkbon',
            },
            'HOME': {   
                'TITEL' : 'Home',
            },
            'HOMEKLANT': {   
                'TITEL' : 'Home',
            },
            'PLANNINGSIMPEL': {   
                'TITEL' : 'Overzicht',
            }
            ,
            'PLANNINGSIMPELKLANT': {   
                'TITEL' : 'Overzicht',
            }
           
        }
    }
};
